import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'pcw-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Physicians Care Walk-In Clinic',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2000,
  email: 'support@phycare.net',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/pcw/index.js